import { useRef, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { AuthShell, Field } from "@/components/AuthShell";

export default function Register() {
  const { user, loading, register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ company: "", name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submitted = useRef(false);
  if (!loading && user && !submitted.current) return <Navigate to="/app" replace />;

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) return setError("Le mot de passe doit contenir au moins 8 caractères.");
    setBusy(true);
    setError("");
    try {
      submitted.current = true;
      await register(form);
      navigate("/app/agents");
    } catch (err) {
      submitted.current = false;
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell kicker="ESSAI GRATUIT" title="Créer votre espace">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <Field label="Société">
          <Input data-testid="register-company-input" required value={form.company} onChange={set("company")} placeholder="Ma société informatique" />
        </Field>
        <Field label="Votre nom">
          <Input data-testid="register-name-input" required value={form.name} onChange={set("name")} />
        </Field>
        <Field label="E-mail">
          <Input data-testid="register-email-input" type="email" required value={form.email} onChange={set("email")} />
        </Field>
        <Field label="Mot de passe (8 caractères min.)">
          <Input data-testid="register-password-input" type="password" required value={form.password} onChange={set("password")} />
        </Field>
        {error && <p data-testid="register-error" className="text-sm text-red-400">{error}</p>}
        <Button data-testid="register-submit-btn" type="submit" disabled={busy} className="w-full rounded-full font-semibold">
          {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Créer mon compte administrateur
        </Button>
      </form>
      <p className="text-sm text-slate-400 mt-8">
        Déjà inscrit ? <Link to="/login" className="text-sky-400 hover:underline" data-testid="go-login-link">Se connecter</Link>
      </p>
    </AuthShell>
  );
}
